import React from 'react';
import { PinInput as CkInput, PinInputField } from '@chakra-ui/react';

import { HStack } from '@/components';

const PinInput = React.forwardRef<
  HTMLInputElement,
  {
    numberOfPinInputField: number;
    setValuePinInput: (value: string) => void;
    onComplete: (valuePinInput: string, number: number) => Promise<void> | null;
    value: string;
  }
>(({ numberOfPinInputField, setValuePinInput, onComplete, value, ...rest }) => {
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData.getData('Text').trim();
    if (/^\d+$/.test(pasted)) {
      e.preventDefault();
      const trimmed = pasted.slice(0, numberOfPinInputField);
      setValuePinInput(trimmed);
      if (trimmed.length === numberOfPinInputField) {
        void onComplete(trimmed, numberOfPinInputField);
      }
    }
  };

  return (
    <HStack dir="ltr" gap={'8px'} justifyContent="center">
      <CkInput
        type="number"
        placeholder=""
        otp
        onChange={(valueInput) => setValuePinInput(valueInput)}
        autoFocus
        manageFocus
        variant="filled"
        onComplete={(valueInput) =>
          void onComplete(valueInput, numberOfPinInputField)
        }
        value={value}
        {...rest}
      >
        {Array.from({ length: numberOfPinInputField }, (_, i) => (
          <PinInputField
            key={i}
            _focusVisible={{ border: '1.2px solid', borderColor: 'text' }}
            backgroundColor="gray.200"
            maxLength={1}
            width="36px"
            padding="0"
            borderRadius="2xs"
            autoFocus={i === 0}
            onPaste={i === 0 ? handlePaste : undefined}
          />
        ))}
      </CkInput>
    </HStack>
  );
});

PinInput.displayName = 'PinInput';
export default PinInput;
